import { FC, MouseEvent } from "react";
import { X } from "lucide-react";

import { Button } from "@/components/_atoms/button";

type DateClearControlSize = "sm" | "xs";

interface DateClearControlProps {
  onClear: (event: MouseEvent<HTMLButtonElement>) => void;
  label: string;
  size: DateClearControlSize;
}

const CONTROL_CLASS_NAME: Record<DateClearControlSize, string> = {
  sm: "absolute right-1 top-1/2 h-6 w-6 -translate-y-1/2 rounded-sm p-1 hover:bg-muted",
  xs: "absolute right-1.5 top-1/2 h-5 w-5 -translate-y-1/2 rounded-sm p-0.5 hover:bg-muted",
};

const ICON_CLASS_NAME: Record<DateClearControlSize, string> = {
  sm: "h-4 w-4 text-muted-foreground",
  xs: "h-3 w-3 text-muted-foreground",
};

export const DateClearControl: FC<DateClearControlProps> = ({ onClear, label, size }) => (
  <Button size="icon" variant="ghost" onClick={onClear} className={CONTROL_CLASS_NAME[size]} aria-label={label}>
    <X className={ICON_CLASS_NAME[size]} aria-hidden="true" />
  </Button>
);
